import type { ComponentsObj } from '@app/types/Global';

const Components: ComponentsObj = {
	'main-hero': async () => await import('./MainHero.svelte'),
	sectors: async () => await import('./Categories.svelte'),
	'logged-in-HP-carousel': async () =>
		await import('./loggedInHPCarousel/LoggedInHPCarousel.svelte'),
	'wiseed-assets': async () => await import('./WiseedAssets.svelte'),
	highlights: async () => await import('./Highlights.svelte'),
	'funding-operations': async () => await import('./FundingOperations.svelte'),
	'3-funding-operations': async () => await import('./layouts/ThreeFundingOperations.svelte'),
	'3-funded-operations': async () => await import('./layouts/ThreeFundedOperations.svelte'),
	'hero-discover': async () => await import('./HeroDiscover.svelte'),
	stats: async () => await import('./Stats.svelte'),
	'wiseed-labels': async () => await import('./WiseedLabels.svelte'),
	testimonies: async () => await import('./testimonies/Testimonies.svelte'),
	'centered-block': async () => await import('./CenteredBlock.svelte'),
	boxes: async () => await import('./layouts/Boxes.svelte'),
	'highlight-blue': async () => await import('./HighlightBlue.svelte'),
	'CTA-link-arrow': async () => await import('./CMSCallToAction.svelte'),
	'CTA-link-box': async () => await import('./CMSCallToAction.svelte'),
	'CTA-link-box-white-border': async () => await import('./CMSCallToAction.svelte'),
	'CTA-link-box-white': async () => await import('./CMSCallToAction.svelte'),
	'CTA-link-box-secondary': async () => await import('./CMSCallToAction.svelte'),
	'content-section': async () => await import('./ContentSection.svelte'),
	'section-action': async () => await import('./SectionAction.svelte'),
	'hero-action': async () => await import('./HeroAction.svelte'),
	employees: async () => await import('./layouts/Employees.svelte'),
	FAQs: async () => await import('./FAQs.svelte'),
	'double-video': async () => await import('./layouts/DoubleVideo.svelte'),
	video: async () => await import('./layouts/Video.svelte'),
	'text-block': async () => await import('./TextBlock.svelte'),
	'scoring-esg': async () => await import('../scoring-esg/ScoringESG.svelte'),
	partner: async () => await import('./Partner.svelte'),
	'process-step': async () => await import('./ProcessSteps.svelte'),
	'box-3-CTA': async () => await import('./TitleWith3CTA.svelte'),
	'bloc-5-mise-en-avant': async () => await import('./Bloc5MiseEnAvant.svelte'),
	'bloc-4-mise-en-avant': async () => await import('./Bloc4MiseEnAvant.svelte'),
	'CTA-3-media-bloks': async () => await import('./CTA3MediaBlok.svelte'),
	'bloc-box-rendement': async () => await import('./BlocBoxRendement.svelte'),
	'CTA-with-title': async () => await import('./TitleWith1CTA.svelte'),
	section: async () => await import('./Section.svelte'),
	slogan: async () => await import('./Slogan.svelte'),
	newsletter: async () => await import('./BlockNewsletter.svelte'),
	'bloc-2-cols': async () => await import('./Bloc2Cols.svelte'),
	'bloc-text-CTA': async () => await import('./BlocTextCTA.svelte'),
	'marketing-partners': async () => await import('./layouts/MarketingPartners.svelte'),
	'contact-form': async () => await import('../contact/ContactForm.svelte'),
	'all-articles': async () => await import('./blog/AllArticles.svelte'),
	'search-articles-box': async () => await import('./blog/SearchArticlesBox.svelte'),
	'hp-title': async () => await import('./HpTitle.svelte'),
	'lp-hero': async () => await import('./landing-pages/HeroLandingPage.svelte'),
	'inline-icon-text': async () => await import('./InlineIconText.svelte'),
	benefits: async () => await import('./landing-pages/Benefits.svelte'),
	'good-to-know': async () => await import('./landing-pages/GoodToKnow.svelte'),
	'why-invest': async () => await import('./landing-pages/WhyInvest.svelte'),
	'masonry-grid': async () => await import('./landing-pages/MasonryGrid.svelte'),
	'lp-testimonies': async () => await import('./landing-pages/TestimoniesLandingPage.svelte'),
	'lp-blog-articles': async () => await import('./landing-pages/LandingPageBlogArticles.svelte'),
	certifications: async () => await import('./landing-pages/Certifications.svelte')
};

// la fonction ci-dessous permet de récupérer le composant Svelte correspondant au composant du CMS via son nom (c.component)
export const getCMSComponents = async (CMSData): Promise<ComponentsObj[]> => {
	let componentsArray;
	await Promise.all(
		CMSData.map(async (c) => {
			if (!Components[c.component]) {
				// composant CMS "coquille vide" qui permet juste de savoir où afficher du custom dans le template
				// il n'a pas d'équivalent en composant Svelte
				// ex: "form-depot-dossier"
				return {
					CMSComp: c
				};
			}
			if (c.component === 'content-section') {
				// le composant CMS "content-section" peut lui même contenir d'autres composants, il faut donc récupérer les composants Svelte équivalents
				await Promise.all(
					c.body.map(async (c) => {
						return {
							svelteComp: await (await Components[c.component]()).default,
							CMSComp: c
						};
					})
				).then((results) => (c.body = results));
			}
			if (c.component === 'section') {
				// le composant CMS "section" peut lui même contenir d'autres composants, il faut donc récupérer les composants Svelte équivalents
				await Promise.all(
					c.components.map(async (c) => {
						return {
							svelteComp: await (await Components[c.component]()).default,
							CMSComp: c
						};
					})
				).then((results) => (c.components = results));
			}
			return {
				svelteComp: await (await Components[c.component]()).default,
				CMSComp: c
			};
		})
	).then((results) => (componentsArray = results));
	return componentsArray;
};
